
import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import { Watch } from "vue-property-decorator";

import CommonTitle from "./components/commonTitle.vue";

@Component({
  components: { CommonTitle },
})
export default class ProductCenter extends Vue {
  products: any = [
    // { title: "售楼",user:"滕永红(13480991677)" },
    // { title: "成本",user:"刘鹏（13971050863）" },
    // { title: "计划",user:"龚伟（18682260108）" },
    // { title: "采招",user:"彭聪（18802715540）" },
    // { title: "费用",user:"张进成（13871288992）" },
    // { title: "经营分析",user:"翟建寿（18086614580）" },    
    // { title: "主数据",user:"周勐（18171029998）" },
    // { title: "增值类产品",user:"程容（15377552839）"},
    { title: "更多",user:"" },
  ];
  handleClick(prod: any) {
    prod.title = prod.title == "更多" ? "" : prod.title;
    this.$router.push({
      path: "/home/contactview",
      query: { tab: prod.title },
    });
  }
}
